export const MAX_SAFE_TIMEOUT = 2147483647
